// JWT payload decode (URL-safe base64 처리 + 패딩 보정)
function parseJwt(token) {
  try {
    let base64 = token.split(".")[1]
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    // ★ 추가: base64 padding 보정 (길이를 4의 배수로 맞춤)
    while (base64.length % 4 !== 0) {
      base64 += "=";
    }

    const decoded = (typeof window !== "undefined" ? window.atob : atob)(base64);
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

export function saveTokens(access, refresh) {
  if (access) localStorage.setItem("accessToken", access);
  if (refresh) localStorage.setItem("refreshToken", refresh);
}

export function clearTokens() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
}

export function getAccessToken() {
  return localStorage.getItem("accessToken");
}

export function getRefreshToken() {
  return localStorage.getItem("refreshToken");
}

export function isTokenValid(token) {
  if (!token) return false;
  const payload = parseJwt(token);
  if (!payload?.exp) return false;
  const now = Math.floor(Date.now() / 1000);
  return payload.exp > now;
}

// ⏱ 남은 시간(초) 계산: access/refresh 공용
export function getTokenRemainingTime(token) {
  if (!token) return 0;
  const payload = parseJwt(token);
  if (!payload?.exp) return 0;
  const now = Math.floor(Date.now() / 1000);
  return Math.max(0, payload.exp - now);
}

// 만료까지 threshold(초) 이하인가? (access 선제 갱신용)
export function isTokenNearlyExpired(token, thresholdSec = 60) {
  const remain = getTokenRemainingTime(token);
  return remain <= thresholdSec;
}
